import styled from 'styled-components';

import { breakpoints } from '../../constants';

export const MapLocationBarWrapper = styled.div`
    position: absolute;
    z-index: 4;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;

    @media (${breakpoints.mediumMin}) {
        display: none;
    }
`;
